<template>
    <div class="order-type">
        <div
            v-if="hasBothOrderTypes"
            class="order-type-switch"
            :class="{ disabled }"
        >
            <input
                :checked="orderType === 'deliver'"
                @input="setType('deliver')"
                type="radio"
                class="order-type-switch-input"
                name="type"
                id="deliver"
                value="deliver"
            >
            <label
                for="deliver"
                class="order-type-switch-label order-type-switch-deliver"
            >
                Bezorgen
            </label>
            <input
                :checked="orderType === 'pickup'"
                @input="setType('pickup')"
                type="radio"
                class="order-type-switch-input"
                name="type"
                id="pickup"
                value="pickup"
            >
            <label
                for="pickup"
                class="order-type-switch-label order-type-switch-pickup"
            >
                Afhalen
            </label>
            <span class="order-type-switch-selection"></span>
        </div>
        <div v-else class="order-type-message">
            <template v-if="orderType === 'deliver'">
                <p class="order-type-message-title">Bezorgen</p>
                <p class="order-type-message-content">
                    Het is bij {{ restaurant.name }} alleen mogelijk
                    om je bestelling te laten bezorgen
                </p>
            </template>
            <template v-else>
                <p class="order-type-message-title">Afhalen</p>
                <p class="order-type-message-content">
                    Het is bij {{ restaurant.name }} alleen
                    mogelijk om je bestelling af te halen
                </p>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';

    export default {
        name: 'CheckoutOrderType',
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            ...mapState({
                settings: state => state.products.settings,
                restaurant: state => state.products.restaurant,
                orderType: state => state.cart.orderType,
            }),
            hasBothOrderTypes() {
                if (!this.settings) return false;
                return this.settings.deliver && this.settings.pickup;
            },
        },
        mounted() {
            this.setDefaultType();
        },
        methods: {
            ...mapMutations({
                setOrderType: 'cart/setOrderType',
            }),

            setType(type) {
                this.setOrderType(type);
                window.localStorage.setItem('order_type', type);
            },

            setDefaultType() {
                const storedItem = window.localStorage.getItem('order_type');
                let type = 'deliver';

                if (!this.settings) return;
                if (this.hasBothOrderTypes) {
                    if (storedItem) this.setType(storedItem);
                    else this.setType(type);
                } else {
                    if (this.settings.deliver) type = 'deliver';
                    if (this.settings.pickup) type = 'pickup';
                    this.setType(type);
                }
            },
        },
    };
</script>

<style lang="scss">
    .order-type {
        &-switch {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 40px;
            margin-top: 16px;
            background: #fff;
            border-radius: 20px;

            &-input {
                display: none;

                &:checked {
                    + .order-type-switch-label {
                        color: #fff;
                    }

                    + .order-type-switch-pickup ~ .order-type-switch-selection {
                        left: calc(50% - 2px);
                    }
                }
            }

            &-label {
                position: relative;
                z-index: 30;
                display: flex;
                flex: 1 0 50%;
                align-items: center;
                justify-content: center;
                max-width: 50%;
                height: 100%;
                font-size: 16px;
                font-weight: bold;
                color: $silver-chalice;
                text-align: center;
                transition: color 0.25s ease;
            }

            &-selection {
                position: absolute;
                left: 2px;
                display: block;
                width: 50%;
                height: 36px;
                background: var(--accentColor);
                border-radius: 20px;
                transition: 0.25s ease;
                transition-property: left, right;
            }
        }

        &-message {
            padding: 12px;
            margin-top: 16px;
            text-align: center;
            background: #fff;
            border-radius: 6px;

            &-title {
                margin-bottom: 4px;
                font-size: 16px;
                font-weight: bold;
                color: $mine-shaft;
                text-align: center;
            }

            &-content {
                margin: 0;
                font-size: 14px;
                line-height: 1.2;
                color: $silver-chalice;
                text-align: center;
            }
        }
    }
</style>
